var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOppoAppMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1BD181;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#A1E6C6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.722,47.75H14.278c-7.747,0-14.028-6.281-14.028-14.028V14.278C0.25,6.531,6.531,0.25,14.278,0.25h19.444 c7.747,0,14.028,6.281,14.028,14.028v19.444C47.75,41.469,41.469,47.75,33.722,47.75z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.726,8.279c0.282,3.71,3.35,6.596,6.951,6.664c3.779,0.071,7.058-2.981,7.236-6.886 c-0.03-1.016,0.753-1.832,1.628-1.87c0.964-0.041,1.875,0.87,1.772,1.993c-0.254,5.547-4.759,9.971-10.151,10.147 c-5.622,0.183-10.538-4.306-10.838-10.092c-0.05-1.006,0.716-1.835,1.599-1.887C15.887,6.291,16.801,7.174,16.726,8.279z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.246,28.207v3.437h-3.437c-1.9,0-3.437-1.537-3.437-3.437c0-1.889,1.538-3.437,3.437-3.437 S23.246,26.318,23.246,28.207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.623,28.207v3.437h3.437c1.9,0,3.437-1.537,3.437-3.437c0-1.889-1.538-3.437-3.437-3.437 S24.623,26.318,24.623,28.207z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.706,36.648v-3.437h3.437c1.9,0,3.437,1.537,3.437,3.437c0,1.889-1.538,3.437-3.437,3.437 S24.706,38.537,24.706,36.648z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.329,36.648v-3.437h-3.437c-1.9,0-3.437,1.537-3.437,3.437c0,1.889,1.538,3.437,3.437,3.437 S23.329,38.537,23.329,36.648z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOppoAppMarket);
export default __webpack_public_path__ + "static/media/icon_oppo_app_market.ed91f0a8f45717df5e9864712c0c89fe.svg";
export { ForwardRef as ReactComponent };